import { Link } from 'react-router-dom';
import { tracking } from '../../utils/tracking';
import { svgs } from '../../assets/svgs';


export const RegisterCards = ({cards,header}) => {

   return (
      <div className='register-cards'>
         {header&&<h1>{header}</h1> }
         <div className='cards-container'>
            {
               cards.map((card, i) =>
                  <div key={i} className='card'>
                     <img src={card.img} alt="" />
                     <h4>{card.title}</h4>
                     <p>{card.content1}</p>
                     <p>{card.content2}</p>
                     <div className="btn-container">
                     <Link style={{background:card.btnColor}} className='btn b3 register-btn' to={card.btnLink} onClick={() => tracking(card.btnId)}>{card.btnTxt}</Link>
                     </div>
                  </div>
               )
            }
         </div>
      </div>
   );
};
